import _ from 'lodash';
import { useEffect } from 'react';
import { useIsAuthenticated, useAccountIdState, useAccounts, useUserInfo } from 'state';

export default function useSetAccountIdFromUser() {
    const isAuthenticated = useIsAuthenticated();
    const accounts = useAccounts();
    const { isInternalUser, accountId: defaultAccountId } = useUserInfo();
    const [accountId, setAccountId] = useAccountIdState();

    useEffect(() => {
        if (isAuthenticated && !isInternalUser && !accountId) {
            const newAccountId = defaultAccountId ?? (!_.isEmpty(accounts) ? accounts[0].accountId : undefined);
            if (newAccountId) {
                setAccountId(newAccountId);
            } else {
                console.error('Account ID could not be found');
            }
            // Remove old localStorage value
            localStorage.removeItem('accountId');
        }
    }, [accountId, accounts, isAuthenticated, isInternalUser, setAccountId, defaultAccountId]);
};